





















import Vue from "vue";
import Component from "vue-class-component"; 
import { Prop } from "vue-property-decorator";

@Component({
})
export default class TinhamosCard extends Vue {
  @Prop() readonly loading!: boolean;
  @Prop() readonly totalPago!: number;
}
